import { Box } from '@mui/material';
import styled from 'styled-components';
import { colors } from '../../../utils';

const { colorPrimary, colorWhite, primaryText,colorSecondary } = colors;

export const Header = styled.div`
	width: 100%;
	background-color: ${colorPrimary};
	color: ${colorWhite};
	padding: ${(props) => (props.padding ? props.padding : '1rem 1.5rem')};
	display: flex;
	justify-content: space-between;
	align-items: center;
	position: sticky;
	top: -0.1px;
	z-index: 91111 !important;
`;

export const Footer = styled.footer`
	padding: 1.5rem 4rem;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 2rem;
`;

export const Box_ = styled(Box)`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: ${(props) => (props.width ? props.width : '40%')};
	background-color: ${primaryText};
	box-shadow: 24;
	max-height: 75%;
	overflow-y: auto;
	overflow-x: hidden;
	z-index: 222222 !important;

	@media only screen and (max-width: 1400px) {
		width: ${(props) => (props.width1400 ? props.width1400 : '50%')};
	}

	@media only screen and (max-width: 1200px) {
		width: ${(props) => (props.width1200 ? props.width1200 : '55%')};
	}

	/* width */
	/* &::-webkit-scrollbar {
		width: 10px;
	} */

	/* Track */
	/* &::-webkit-scrollbar-track {
		border-radius: 10px;
		margin: 10rem 0;
	} */

	/* Handle */
	/* &::-webkit-scrollbar-thumb {
		background: ${colorPrimary};
		border-radius: 10px;
	} */

	/* Handle on hover */
	/* &::-webkit-scrollbar-thumb:hover {
		background: var(--primary-color);
	} */
`;
